import { useEffect } from "react";
import { useSelector } from "react-redux";
import { FriendList } from "./FriendList";
import { useLazyGetFriendRequestsQuery } from "@/services/modules/chat";
import { RootState } from "@/store/reducers";
import FriendRequest from "./FriendRequest";

export const FriendRequestList = () => {
  const [getFriendsData] = useLazyGetFriendRequestsQuery();
  const allFriendsList = useSelector(
    (state: RootState) => state.chat.friendRequestList
  );

  useEffect(() => {
    getFriendsData();
  }, []);

  return (
    <FriendList
      friendList={allFriendsList}
      Item={({ item }) => <FriendRequest recipient={item} />}
    />
  );
};
